var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"menu-level"},_vm._l((_vm.items),function(item,index){return _c('TheMenuItem',{key:item.text,attrs:{"content":item,"index":index}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }